import { render, staticRenderFns } from "./ProcessingInfo.vue?vue&type=template&id=ec5cf87c&scoped=true&"
import script from "./ProcessingInfo.vue?vue&type=script&lang=js&"
export * from "./ProcessingInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingInfo.vue?vue&type=style&index=0&id=ec5cf87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5cf87c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec5cf87c')) {
      api.createRecord('ec5cf87c', component.options)
    } else {
      api.reload('ec5cf87c', component.options)
    }
    module.hot.accept("./ProcessingInfo.vue?vue&type=template&id=ec5cf87c&scoped=true&", function () {
      api.rerender('ec5cf87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/ProcessingInfo.vue"
export default component.exports